<template>
    <!-- each sub category -->
    <tr>
        <th scope="row">{{ counter }}.</th>
        <td class="text-capitalize text-truncate">{{subCategoryObj.subCategory}}</td>
        <td class="text-center">
            <div class="d-block">
                <input v-model="expressFee" v-bind="{disabled : !editFees}" type="number" class="form-control no-lines">
                <select v-model="expressDays" v-bind="{disabled : !editFees}" class="custom-select no-lines" style="border-color: #DFDFDF;">
                    <option selected disabled value="">days</option>
                    <option v-for="(day, i) in totalDays" :key="i" :value="day">{{day}}</option>
                </select>
            </div>
        </td>
        <td class="text-center">
            <input v-model="economyFee" v-bind="{disabled : !editFees}" type="number" class="form-control no-lines">
            <select v-model="economyDays" v-bind="{disabled : !editFees}" class="custom-select no-lines" style="border-color: #DFDFDF;">
                <option selected disabled value="">days</option>
                <option v-for="(day, i) in totalDays" :key="i" :value="day">{{day}}</option>
            </select>
        </td>
        <td class="text-center">
            <input v-model="budgetFee" v-bind="{disabled : !editFees}" type="number" class="form-control no-lines">
            <select v-model="budgetDays" v-bind="{disabled : !editFees}" class="custom-select no-lines" style="border-color: #DFDFDF;">
                <option selected disabled value="">days</option>
                <option v-for="(day, i) in totalDays" :key="i" :value="day">{{day}}</option>
            </select>
        </td>
        <td class="text-center">
            <button v-if="editFees" @click.prevent="addShippingFeeFxn" class="btn btn-dark-green"><i class="fas fa-save"></i></button>
            <button v-else @click.prevent="editFeeFxn" class="btn btn-outline-dark"><i class="fas fa-pencil-alt"></i></button>
        </td>
    </tr>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    name: "SubCategoryFee",
    props: {
        counter: {
            type: Number,
            required: true
        },
        categoryName: {
            type: String,
            required: true
        },
        subCategoryObj: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            expressFee: 0,
            expressDays: '',
            economyFee: 0,
            economyDays: '',
            budgetFee: 0,
            budgetDays: '',
            totalDays: 30,
            editFees: false
        }
    },
    methods: {
        ...mapActions(['addShippingFeeAction']),
        editFeeFxn() {
            this.editFees = true
        },
        addShippingFeeFxn() {
            this.editFees = false
            let subCategoryFeeObj = {
                categoryName: this.categoryName,
                subCategoryId: this.subCategoryObj._id,
                expressFee: this.expressFee,
                expressDays: this.expressDays,
                economyFee: this.economyFee,
                economyDays: this.economyDays,
                budgetFee: this.budgetFee,
                budgetDays: this.budgetDays,
            }
            this.addShippingFeeAction(subCategoryFeeObj)
            .then((data) => {
                if(!data.error){
                    this.autoAssignValuesFxn()
                }
            }).catch((e) => {})
        },
        autoAssignValuesFxn() {
            // ensure the subCategory obj exists
            if(!this.subCategoryObj) return
            
            // store the shippingFees property unto a variable
            let subCategoryFees = this.subCategoryObj.shippingFees
            this.expressFee = subCategoryFees.express ? subCategoryFees.express : this.expressFee
            this.expressDays = subCategoryFees.expressDays ? subCategoryFees.expressDays : this.expressDays
            this.economyFee = subCategoryFees.economy ? subCategoryFees.economy : this.economyFee
            this.economyDays = subCategoryFees.economyDays ? subCategoryFees.economyDays : this.economyDays
            this.budgetFee = subCategoryFees.budget ? subCategoryFees.budget : this.budgetFee
            this.budgetDays = subCategoryFees.budgetDays ? subCategoryFees.budgetDays : this.budgetDays
        }
    },
    watch: {
        subCategoryObj() {
            this.autoAssignValuesFxn()
        }
    },
    created() {
        this.autoAssignValuesFxn()
    }
}
</script>